import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  max-width: 28rem;

  & > h2 {
    font-weight: bold;
    margin: unset;
    color: ${({ theme }) => theme.colors.grayDark2};
  }

  & > span {
    font-size: 1rem;
    text-align: center;
  }

  & > .actions {
    display: flex;
    flex-direction: column;
    margin-top: 5.625rem;
    width: 23rem;

    & > button {
      margin-bottom: 0.875rem;
    }
  }
`;

export const TitleContainer = styled.div`
  padding-top: 1rem;
`;

export const ErrorCircleIcon = styled.div`
  font-size: 0.063rem;
`;
